
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/governance",
      function () {
        return require("private-next-pages/governance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/governance"])
      });
    }
  